import { type PropsWithChildren, useEffect } from 'react';

import * as Sentry from '@sentry/react';

import { configureDatadog } from '@storebrand-digital/common-datadog';

import { isDevEnv } from '../../app/utils/env';

import { getDatadogEnvironment, getSentryEnvironment } from './utils';

const iwaEnv = window.env.ENVIRONMENT;
const appName = window.env.CLIENT_ID;
interface Props {
  version: string;
}

function initDatadog(appVersion: string) {
  return configureDatadog({
    appId: 'ee4578a7-cbd1-4ad0-b346-f9a981459d72',
    appName,
    appVersion: appVersion.toLowerCase(),
    clientPublicToken: 'pubeb1da1e3857ff5ba18cf9b2e15142178',
    configureLogging: true,
    environment: getDatadogEnvironment(iwaEnv),
  });
}

function initSentry(release: string) {
  return Sentry.init({
    dsn: window.env.SENTRY_PUBLIC_KEY,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    release,
    environment: getSentryEnvironment(iwaEnv),
  });
}

export default function MonitoringProvider({ version, children }: PropsWithChildren<Props>) {
  useEffect(() => {
    // NOTE: We're currently using both Datadog and Sentry since we're testing out which tool we'll be using

    if (iwaEnv && !isDevEnv) {
      initDatadog(version);
      initSentry(version);
    }
  }, [version]);

  return <>{children}</>;
}
